import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccordionContent, StyledDescription, StyledDescriptionContainer, StyledIcons, StyledLabel, StyledLabelContainer, StyledListItemAccordionContainer, StyledListItemActionContainer, StyledListItemContainer, } from "./ListItem.style";
import { Checkbox, Divider, Favorite, InformativeTag, Label, NumberBadge, Radio, Switch, } from "../../../Atoms";
import { isValidElement, useRef, useState } from "react";
import BrandAvatar from "../../../Molecules/Images/BrandAvatar/BrandAvatar";
import { CSSTransition } from "react-transition-group";
import CardholderAvatar from "../../../Molecules/Images/CardholderAvatar/CardholderAvatar";
import { Icon } from "../../../Molecules";
import UserAvatar from "../../../Molecules/Images/UserAvatar/UserAvatar";
import { nanoid } from 'nanoid';
const ListItem = ({ accordionContent = _jsx(_Fragment, {}), actionIcon, actionIconElement, actionOnClick = () => { }, avatarIcon, avatarIconElement, AvatarSize = "small", avatarUrl, avatarVariant, badge = "", brandVariant = "original", cardVariant = "card", descript = "", hasHover = true, hasLine = true, hasError = false, initialValue = false, label = "", radioValue = "", radioChecked = false, radioOnChange = () => { }, selectorIsDisabled = false, selectorName = "", selectorOnChange = () => { }, selectorVariant = "switch", subDescript = "", subLabel = "", tag = "", variant = "simple", ...props }) => {
    const [accordionActive, setAccordionActive] = useState(false);
    const listItemSelectorId = useRef(nanoid());
    const animationClassNames = {
        enter: "accordion-fade-in-start",
        enterActive: "accordion-fade-in-moderate-end",
        enterDone: "accordion-fade-in-moderate-end",
        exit: "accordion-fade-out-start",
        exitActive: "accordion-fade-out-moderate-end",
        exitDone: "accordion-fade-out-moderate-end",
    };
    const handleDescriptionType = () => {
        if (badge) {
            return (_jsx(NumberBadge, { variant: "primary", value: badge, lockMobile: true }));
        }
        if (descript && subDescript) {
            return (_jsxs(StyledDescription, { children: [_jsx(Label, { size: "medium", variant: "neutral", children: descript }), _jsx(Label, { size: "small", variant: "neutral", children: subDescript })] }));
        }
        if (descript) {
            return _jsx(Label, { size: "medium", variant: "neutral", children: descript });
        }
        if (tag) {
            return (_jsx(InformativeTag, { type: hasError ? "error" : "neutral", variant: "outlined", children: tag }));
        }
        return;
    };
    const handleSelectorType = () => {
        const selectorSharedProps = {
            id: listItemSelectorId.current,
            name: selectorName,
            initialState: initialValue,
            isDisabled: selectorIsDisabled,
            onChange: selectorOnChange,
        };
        switch (selectorVariant) {
            case "switch":
                return (_jsx(Switch, { ...selectorSharedProps, initialState: initialValue }));
            case "checkbox":
                return (_jsx(StyledIcons, { children: _jsx(Checkbox, { ...selectorSharedProps }) }));
            case "favorite":
                return (_jsx(StyledIcons, { children: _jsx(Favorite, { ...selectorSharedProps }) }));
            case "feedback":
                return (_jsx(StyledIcons, { children: _jsx(Favorite, { ...selectorSharedProps, variant: true }) }));
            case "radio":
                return (_jsx(StyledIcons, { children: _jsx(Radio, { ...selectorSharedProps, onChange: radioOnChange, value: radioValue, isChecked: radioChecked, ...props }) }));
        }
    };
    const handleItemVariant = () => {
        switch (variant) {
            case "selector":
                return handleSelectorType();
            case "action":
                return (_jsxs(_Fragment, { children: [handleDescriptionType(), actionIcon ? (_jsx(StyledIcons, { children: _jsx(Icon, { name: actionIcon }) })) : isValidElement(actionIconElement) ? ({ avatarIconElement }) : (_jsx(StyledIcons, { className: "action-icon", children: _jsx(Icon, { name: "itaufonts_seta_right" }) }))] }));
            case "accordion":
                return (_jsxs(_Fragment, { children: [handleDescriptionType(), _jsx(StyledIcons, { children: _jsx(Icon, { className: accordionActive ? "accordion-icon active" : "accordion-icon", name: "itaufonts_seta_down" }) })] }));
            default:
                return handleDescriptionType();
        }
    };
    const handleAvatarVariant = () => {
        switch (avatarVariant) {
            case "brand":
                return ((!!avatarUrl && (_jsx(BrandAvatar, { brandSize: AvatarSize === "small" ? "small" : "medium", variants: brandVariant, imgUrl: avatarUrl }))) ||
                    (!!avatarIcon && (_jsx(BrandAvatar, { brandSize: AvatarSize === "small" ? "small" : "medium", variants: brandVariant, iconName: avatarIcon }))));
            case "card":
                return (_jsx(CardholderAvatar, { size: AvatarSize === "small" ? "small" : "medium", variant: cardVariant }));
            case "user":
                return (!!avatarUrl && (_jsx(UserAvatar, { imgUrl: avatarUrl, avatarSize: AvatarSize === "small" ? "small" : "medium" })));
            case "icon": {
                if (avatarIcon)
                    return (_jsx(StyledIcons, { className: "avatar-icon", children: _jsx(Icon, { name: avatarIcon, ...props.avatarIconProperties, size: AvatarSize }) }));
                if (isValidElement(avatarIconElement))
                    return avatarIconElement;
                return _jsx(_Fragment, {});
            }
        }
        return;
    };
    const renderContent = () => {
        return (_jsxs(_Fragment, { children: [handleAvatarVariant(), _jsxs(StyledLabelContainer, { children: [_jsx(StyledLabel, { size: "medium", variant: "neutral", isVariant: true, children: label }), !!subLabel && (_jsx(StyledLabel, { size: "small", variant: "neutral", children: subLabel }))] }), _jsx(StyledDescriptionContainer, { children: handleItemVariant() })] }));
    };
    const renderListItem = () => {
        switch (variant) {
            case "action":
                return (_jsxs(_Fragment, { children: [_jsx(StyledListItemActionContainer, { hasHover: hasHover, subLabel: subLabel, subDescript: subDescript, onClick: actionOnClick, ...props, children: renderContent() }), hasLine && _jsx(Divider, { variant: "neutral", weight: "light" })] }));
            case "accordion":
                return (_jsxs(StyledListItemAccordionContainer, { children: [_jsx(StyledListItemActionContainer, { hasHover: hasHover, subLabel: subLabel, subDescript: subDescript, onClick: () => setAccordionActive(!accordionActive), children: renderContent() }), _jsx(Divider, { variant: "neutral", size: accordionActive ? "medium" : "soft", weight: accordionActive ? "regular" : "light" }), _jsx(CSSTransition, { in: accordionActive, timeout: { appear: 400, exit: 400 }, classNames: animationClassNames, mountOnEnter: true, unmountOnExit: true, children: _jsx(AccordionContent, { children: accordionContent }) })] }));
            default:
                return (_jsxs(_Fragment, { children: [_jsx(StyledListItemContainer, { hasHover: hasHover, subLabel: subLabel, variant: variant, subDescript: subDescript, htmlFor: listItemSelectorId.current, children: renderContent() }), hasLine && _jsx(Divider, { variant: "neutral", weight: "light" })] }));
        }
    };
    return renderListItem();
};
export default ListItem;
//# sourceMappingURL=ListItem.js.map